import React, { Component } from "react";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";
import Loading from "../../../components/Loading";

const REQUIRED_INPUT_FILES = [
  "IN_TIME_BUCKET.csv", "IN_FX_RATE.csv", "IN_BASE_INTEREST_RATE.csv",
  "IN_INT_SHOCK_PARAMETER.csv", "IN_INT_SHOCK_SIZE.csv", "IN_BEHAVIORAL_MODEL.csv",
  "IN_BEHAVIORAL_MODEL_MULTIPLIER.csv", "IN_REQUIRED_RESERVE.csv",
  "PAYMENT_SCHEDULE.csv", "CASA.csv", "TD.csv", "LD.csv", "BOND.csv", "BRW.csv",
  "MM.csv", "REPO_RESO.csv", "OD.csv", "CC.csv", "FX_FWD.csv", "FS_SWAP.csv",
  "FUTURE.csv", "IRSCCS.csv",
];

class FileInfo extends Component {
  constructor(props) {
    super(props);
    const fileInfo = (props.location && props.location.state) || {};
    this.state = {
      lstInput: REQUIRED_INPUT_FILES.map((name) => ({
        input: name,
        upload_by: fileInfo.upload_by || "",
        upload_time: Business.convertToFullDate(fileInfo.upload_time),
        select: false,
      })),
      lstOutput: [],
      isSelectAllInput: false,
      isSelectAllOutput: false,
      fileInfo,
      reportDate: Business.convertToDate(fileInfo.report_date),
      reportName: fileInfo.file_name || "",
      status: Business.convertFileStatus(fileInfo.status),
      loading: true,
    };
  }

  componentDidMount() {
    Http.getIrrbbOutputs(this.state.reportName)
      .then((res) => {
        const lstOutput = res && res.Success && res.Data
          ? res.Data.map((o) => ({ output_type: o.output_type, created: Business.convertToFullDate(o.created_time), select: false }))
          : [];
        this.setState({ lstOutput, loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  onSelectInput = (name) => {
    if (name === "SELECT_ALL") {
      const next = !this.state.isSelectAllInput;
      this.state.lstInput.forEach((i) => { i.select = next; });
      this.setState({ isSelectAllInput: next });
    } else {
      this.state.lstInput.forEach((i) => { if (i.input === name) i.select = !i.select; });
      this.forceUpdate();
    }
  };

  onSelectOutput = (name) => {
    if (name === "SELECT_ALL") {
      const next = !this.state.isSelectAllOutput;
      this.state.lstOutput.forEach((i) => { i.select = next; });
      this.setState({ isSelectAllOutput: next });
    } else {
      this.state.lstOutput.forEach((i) => { if (i.output_type === name) i.select = !i.select; });
      this.forceUpdate();
    }
  };

  onDownloadInputFiles = () => {
    const selected = this.state.lstInput.filter((i) => i.select);
    if (!selected.length) return;
    const { reportName, fileInfo } = this.state;
    selected.forEach((item) =>
      Http.downloadIrrbbInputFile(reportName, fileInfo.report_date, item.input)
    );
  };

  onDownloadOutputFiles = () => {
    const selected = this.state.lstOutput.filter((i) => i.select);
    if (!selected.length) return;
    selected.forEach(() => Http.downloadIrrbbReport(this.state.reportName));
  };

  render() {
    const { reportDate, reportName, status } = this.state;
    const shortName = String(reportName).substring("IRRBB_".length);

    return (
      <div className="content">
        <div className="container-fluid">
          <h4 style={{ marginBottom: 20 }}>
            <strong>{reportDate} # {shortName} # {status}</strong>
          </h4>

          {/* INPUT TABLE */}
          <div className="ey-file-table-toolbar">
            <button className="ey-dl-icon-btn" onClick={this.onDownloadInputFiles}>
              <i className="pe-7s-download" />
            </button>
            <span className="ey-file-table-toolbar-label">Download selected files</span>
          </div>
          <div style={{ position: "relative", height: "300px", overflowY: "scroll", marginBottom: "30px" }}>
            <table className="table ey-file-table">
              <thead>
                <tr>
                  <th><input type="checkbox" onChange={() => this.onSelectInput("SELECT_ALL")} checked={this.state.isSelectAllInput} /></th>
                  <th>No.</th>
                  <th>Input</th>
                  <th>Uploader</th>
                  <th>Upload Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.lstInput.map((item, index) => (
                  <tr key={item.input}>
                    <td><input type="checkbox" onChange={() => this.onSelectInput(item.input)} checked={item.select === true} /></td>
                    <td>{index + 1}</td>
                    <td className="ey-file-name">{item.input}</td>
                    <td>{item.upload_by}</td>
                    <td>{item.upload_time}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* OUTPUT TABLE */}
          <div className="ey-file-table-toolbar">
            <button className="ey-dl-icon-btn" onClick={this.onDownloadOutputFiles}>
              <i className="pe-7s-download" />
            </button>
            <span className="ey-file-table-toolbar-label">Download selected files</span>
          </div>
          <div style={{ position: "relative", height: "200px", overflowY: "scroll", marginBottom: "30px" }}>
            {this.state.loading ? (
              <div style={{ height: 80 }}><Loading size="small" /></div>
            ) : (
              <table className="table ey-file-table">
                <thead>
                  <tr>
                    <th><input type="checkbox" onChange={() => this.onSelectOutput("SELECT_ALL")} checked={this.state.isSelectAllOutput} /></th>
                    <th>No.</th>
                    <th>Output</th>
                    <th>CreatedTime</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.lstOutput.map((item, index) => (
                    <tr key={item.output_type}>
                      <td><input type="checkbox" onChange={() => this.onSelectOutput(item.output_type)} checked={item.select === true} /></td>
                      <td>{index + 1}</td>
                      <td className="ey-file-name">{item.output_type}</td>
                      <td>{item.created}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FileInfo;



// WEBPACK FOOTER //
// src/pages/IRRBB/FileManagement/FileInfo.js